var _path, _ellipse, _ellipse2, _path2, _ellipse3, _ellipse4, _path3, _ellipse5, _ellipse6, _path4, _ellipse7, _ellipse8, _path5, _path6, _path7, _path8, _path9, _ellipse9, _path10, _ellipse10, _ellipse11, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoadMob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 365,
    height: 214,
    viewBox: "0 0 365 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M315.846 11.3889C333.019 10.6749 347.997 10.7258 326.821 7.22833C326.821 7.22833 319.374 6.25728 319.197 4.76196C318.972 2.85901 335.084 1.48647 339.6 0.833707L344.587 0.244128C344.587 0.244128 320.66 3.28043 320.7 4.58421C320.741 5.88799 325.555 6.43633 328.49 6.92578C337.368 8.84459 353.17 10.7954 315.928 12.0792C255.714 14.1549 234.242 18.8189 224.2 21.1795C211.117 24.255 219.725 26.6786 222.369 27.3741C225.012 28.0697 241.191 31.8454 246.991 33.6187C258.378 37.0998 263.489 45.9844 228.595 51.7844C194.878 57.3886 65.0891 54.5 50.8607 54.1384C28.7004 53.5753 17.3272 57.446 18.7482 61.1925C22.0702 69.9506 288.97 99.6946 330.389 176.996L37.864 187.647C150.514 87.1799 -1.03782 76.4732 3.58715 61.6188C5.89183 54.2166 35.0871 51.4288 50.585 51.8062C70.2194 52.2842 195.463 54.6793 225.105 50.5221C262.738 45.2443 249.22 36.1755 245.342 35.0829C242.169 34.1888 228.349 30.094 220.936 28.032C217.036 26.9471 209.191 24.2238 222.644 20.8561C240.278 16.4416 266.413 13.4443 315.846 11.3889Z",
    fill: "#293856"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.66097,
    ry: 7.69904,
    transform: "matrix(0.952491 -0.304568 0.326627 0.945153 157.384 113.965)",
    fill: "#0B1428"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.25892,
    ry: 7.69904,
    transform: "matrix(0.952491 -0.304568 0.326627 0.945153 161.571 111.709)",
    fill: "#0B1428"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M159.531 104.12L155.4 106.303L160.332 121.024L164.606 118.688L159.531 104.12Z",
    fill: "#0B1428"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.66097,
    ry: 7.69904,
    transform: "matrix(0.952491 -0.304568 0.326627 0.945153 177.388 101.9)",
    fill: "#0B1428"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.25892,
    ry: 7.69904,
    transform: "matrix(0.952491 -0.304568 0.326627 0.945153 180.58 100.29)",
    fill: "#0B1428"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M178.667 92.6688L174.998 94.7281L180.068 109.03L183.513 107.419L178.667 92.6688Z",
    fill: "#0B1428"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.26876,
    ry: 5.06067,
    transform: "matrix(0.953446 -0.301564 0.331079 0.943603 133.48 102.015)",
    fill: "#0B1428"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.26876,
    ry: 5.06067,
    transform: "matrix(0.953446 -0.301564 0.331079 0.943603 136.672 100.403)",
    fill: "#0B1428"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135.087 95.6994L131.864 97.2557L135.341 106.705L138.528 105.105L135.087 95.6994Z",
    fill: "#0B1428"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.63,
    cy: 101.854,
    rx: 1.26702,
    ry: 2.77366,
    transform: "rotate(162.286 133.63 101.854)",
    fill: "#182944"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.183,
    cy: 114.425,
    rx: 1.90165,
    ry: 4.16293,
    transform: "rotate(162.286 157.183 114.425)",
    fill: "#182944"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M152.88 79.1807L140.315 83.9278L140.159 86.2363C140.159 86.2363 133.135 88.6016 131.727 89.7236C130.886 90.3932 132.772 96.5534 132.772 96.5534L152.519 109.434L153.42 106.822L160.01 109.366L161.149 113.766L163.2 114.816L187.259 101.616L181.207 77.03L152.88 79.1807Z",
    fill: "#3F5475"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M162.723 113.412L163.859 112.404L186.357 100.523L187.122 100.487L187.288 101.231L186.644 101.999L164.17 114.29L162.772 114.463L162.723 113.412Z",
    fill: "#0B1428"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M186.281 102.189L186.056 100.865L186.049 100.708L183.398 102.067L183.703 103.597L186.281 102.189Z",
    fill: "#9B0B13"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M167.648 112.29L167.407 110.886L167.399 110.719L164.537 112.164L164.865 113.787L167.648 112.29Z",
    fill: "#9B0B13"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M156.605 86.6729C154.753 86.9491 139.838 84.041 139.821 83.6984C139.669 80.6328 148.52 78.6863 154.758 77.0706C156.518 76.6148 181.499 73.6537 181.238 77.0326C181.206 77.4429 159.315 86.2688 156.605 86.6729Z",
    fill: "#788BA9"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 166.887,
    cy: 103.724,
    rx: 6.04942,
    ry: 7.08152,
    transform: "rotate(8.76019 166.887 103.724)",
    fill: "#14213C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M168.3 96.7793L170.951 97.6158L167.297 111.396L164.494 110.246L168.3 96.7793Z",
    fill: "#14213C"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 168.99,
    cy: 104.481,
    rx: 5.59471,
    ry: 7.08152,
    transform: "rotate(8.76019 168.99 104.481)",
    fill: "#0B1428"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 169.585,
    cy: 104.587,
    rx: 2.67986,
    ry: 3.68732,
    transform: "rotate(8.76019 169.585 104.587)",
    fill: "#182944"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M169.448 85.3775L162.623 88.1941C162.157 88.3867 161.904 88.8937 162.03 89.3822L163.791 96.1792C163.953 96.8053 164.653 97.1203 165.229 96.8261L171.901 93.4196C172.323 93.2041 172.539 92.7243 172.42 92.2656L170.812 86.0586C170.658 85.4645 170.015 85.1433 169.448 85.3775Z",
    fill: "#24304B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M173.818 90.9171L172.304 85.0728C172.18 84.593 172.422 84.0939 172.875 83.8941L178.373 81.4714C178.944 81.2201 179.604 81.5397 179.76 82.1431L181.225 87.8003C181.346 88.2684 181.119 88.7568 180.683 88.9656L175.233 91.5755C174.659 91.8503 173.977 91.5331 173.818 90.9171Z",
    fill: "#24304B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M156.595 89.1127C157.167 89.1886 157.699 89.1918 158.163 89.138C158.853 89.0583 159.685 89.417 159.859 90.0889L161.525 96.5216C161.647 96.9934 161.417 97.4949 160.95 97.6359C159.217 98.16 157.522 97.7934 156.667 97.1165C156.516 96.9972 156.43 96.8188 156.394 96.63L155.193 90.4437C155.042 89.6684 155.812 89.0087 156.595 89.1127Z",
    fill: "#24304B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M182.686 87.1675L181.015 80.7187C180.932 80.3976 181.012 80.056 181.229 79.8048L181.775 79.1712L183.38 85.789C183.509 86.3195 183.335 86.8777 182.927 87.2408C182.844 87.3143 182.713 87.2745 182.686 87.1675Z",
    fill: "#24304B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M140.437 91.3778L140.993 86.2827C141.027 85.9757 141.325 85.7702 141.624 85.8485L144.003 86.4716C144.192 86.5212 144.336 86.676 144.372 86.8686L145.489 92.9057C145.561 93.2945 145.178 93.6117 144.809 93.4692L140.758 91.9042C140.544 91.8216 140.412 91.6056 140.437 91.3778Z",
    fill: "#24304B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M153.012 88.8731L146.836 87.3531C146.48 87.2656 146.153 87.5735 146.218 87.9338L147.26 93.7099C147.292 93.8842 147.412 94.0294 147.578 94.0925L153.993 96.5391C154.363 96.6802 154.744 96.3606 154.67 95.9718L153.388 89.269C153.351 89.0749 153.204 88.9203 153.012 88.8731Z",
    fill: "#24304B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M128.875 93.8232C129.369 93.3154 132.573 92.2407 132.573 92.2407L137.965 94.6154L141.028 101.643L152.528 109.067L151.791 109.497L139.032 103.45L138.396 103.712L135.11 97.7588L130.368 95.6687L128.933 96.0406C128.933 96.0406 128.134 94.5864 128.875 93.8232Z",
    fill: "#445B7E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadMob);
export default __webpack_public_path__ + "static/media/road-mob.d31d39e49266d09be0143d43f7149398.svg";
export { ForwardRef as ReactComponent };